import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import { siyanda_platinum_dashboard_ids_by_title } from "@/config/dashboardIds";
import is_admin_user from "@/utils/auth_user";
import collapsed_sidebar_tooltip from "@/mixins/collapsed_sidebar_tooltip";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";

//Getting Company details
const details = brand_details();
const default_shaft_menu_item = "shaft-daily-dashboard";
const shaft_ids_by_title = siyanda_platinum_dashboard_ids_by_title;

export default {
  name: "PropertySidebar",

  components: {
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  },

  mixins: [collapsed_sidebar_tooltip],

  props: {
    active_property: {
      type: Object,
      required: true
    },
    properties: {
      type: Array,
      required: true
    },
    active_item: {
      type: String,
      default: default_shaft_menu_item
    },
    can_view_portfolio: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      // MENU STATE
      active_menu_item: default_shaft_menu_item,
      dropdownOpen: false,

      //Sub Entity Details
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,
      brand_name: details.name,
      brand_subtitle: details.subtitle,


      // FOOTER
      full_name: "Guest User",
      initials: "GU",
      is_admin: false,

      // BRAND LOGO
      bolide_short_logo: getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-short-logo")
        .replace(/['"]+/g, "")
    });
  },

  computed: {
    can_access_portfolio() {
      return this.is_admin || this.can_view_portfolio;
    },

    propertiesFormatted() {
      return (this.properties || []).map(item => ({
        id: item.id,
        shaft_id: item.shaft_id || item.id,
        label: item.title,
        title: item.title,
        is_live: item.is_live
      }));
    },

    shaft_id() {
      const title = this.active_property?.title || this.active_property?.name || "";
      return shaft_ids_by_title[title] || this.active_property?.shaft_id || this.active_property?.id || "";
    },

    menuItems() {
      return [
        { key: "shaft-daily-dashboard", label: "Daily Dashboard", icon: "bi bi-calendar-day-fill" },
        { key: "shaft-weekly-dashboard", label: "Weekly Dashboard", icon: "bi bi-calendar-week-fill" },
        { key: "shaft-monthly-dashboard", label: "Monthly Dashboard", icon: "bi bi-calendar-month-fill" }
      ];
    }
  },

  mounted() {
    this.load_user_name();
    this.active_menu_item = this.active_item;
  },

  watch: {
    active_item(newItem) {
      this.active_menu_item = newItem || default_shaft_menu_item;
    },

    active_property(newProperty) {
      if (newProperty) {
        this.selectShaftDashboard();
      }
    }
  },

  methods: {
    /** FOOTER NAME INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";

      this.full_name = name;
      this.initials = initials;
    },

    /** DROPDOWN LOGIC */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    switchProperty(item) {
      this.dropdownOpen = false;

      this.$emit("switch-property", item.id);

      this.active_menu_item = default_shaft_menu_item;
    },

    backToGlobal() {
      if (!this.can_access_portfolio) {
        return;
      }

      this.dropdownOpen = false;
      this.$emit("go-back");
    },

    selectShaftDashboard() {
      this.active_menu_item = default_shaft_menu_item;

      this.$emit("property-menu-selected", {
        menuItem: default_shaft_menu_item,
        propertyId: this.active_property.id,
        propertyName: this.active_property.title
      });
    },

    select_menu_item(menuItem) {
      this.active_menu_item = menuItem;
      this.$emit("property-menu-selected", {
        menuItem,
        propertyId: this.active_property.id,
        propertyName: this.active_property.title
      });
    }
  }
};
